import Vue from "vue";
import Vuex from "vuex";
import API from "@/common/api/api.functions";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    title: "Физико-математическая школа",
    shortTitle: "ФМШ",
    headerBarHeight: 64,
    headerPadding: true,
    courses: [],
    teacherTypes: {}
  },
  mutations: {
    UPDATE_COURSES(state, value) {
      state.courses = value;
    },
    UPDATE_TEACHER_TYPES(state, value) {
      state.teacherTypes = value;
    }
  },
  actions: {
    changePageTitle({ state }, title) {
      document.title = title ? `${state.shortTitle} - ${title}` : state.title;
    },
    async getCourses({ commit }) {
      let courses = await API.getCourses();
      if (0 <= courses.status - 200 < 100)
        commit("UPDATE_COURSES", courses.data);
    },
    async getTeacherTypes({ commit }) {
      let teacherTypes = await API.getTeacherTypes();
      if (0 <= teacherTypes.status - 200 < 100)
        commit("UPDATE_TEACHER_TYPES", teacherTypes.data);
    }
  },
  modules: {},
  getters: {
    title: state => state.title,
    shortTitle: state => state.shortTitle,
    headerBarHeight: state => state.headerBarHeight,
    headerPadding: state => state.headerPadding,
    courses: state => state.courses,
    teacherTypes: state => state.teacherTypes
  }
});
